import { Button as RadixButton } from '@radix-ui/themes';

export default function Button({ onClick, ...props }) {
  const onSingleClick = (event) => {
    if (event.detail > 1) {
      event.preventDefault();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  return <RadixButton onClick={onSingleClick} {...props} />;
}
